/**
 * * @module component/people.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";

const People = Backbone.View.extend({
  el: $(document),

  events: {
    "change #donation-slider": "donationUpdateAmount",
    "input #donation-slider": "donationUpdateAmount",
  },

  initialize: function () {
    this.render();
  },

  donationUpdateAmount: function (e) {
    let value = undefined;
    let $toShow = undefined;

    var _this = this;
    var text = $(".amount-label").data("alt-text");

    if (e) {
      value = $(e.currentTarget).val();
      if ($(".amount-label").text() != text) {
        $(".amount-label").html("Donation amount: &pound;");
      }
      $(".editable").blur();
      $(".editable").text(value);
      $("[data-custom-donation-input]").val(value);
      document
        .getElementById("donation-amount")
        .dispatchEvent(new Event("input", { bubbles: true }));
      document
        .getElementById("donation-amount")
        .dispatchEvent(new Event("change", { bubbles: true }));
    } else {
      value = $('#donation-slider').val();
    }

    if (value <= 5 ) {
      $toShow = $('.per-amount-text[data-amount=5]');
      if ($toShow) {
        _this.showAmountText($toShow);
      }
      
    } else if (value >= 5 && value < 50) {
      $toShow = $('.per-amount-text[data-amount=50]');
      if ($toShow) {
        _this.showAmountText($toShow);
      }
    } else if (value >= 50 && value < 100) {
       $toShow = $('.per-amount-text[data-amount=100]');
      if ($toShow) {
        _this.showAmountText($toShow);
      }
    } else if (value >= 100 && value < 150) {
     $toShow = $('.per-amount-text[data-amount=150]');
      if ($toShow) {
        _this.showAmountText($toShow);
      }
    } else if (value >= 150 && value < 200) {
      $toShow = $('.per-amount-text[data-amount=200]');
      if ($toShow) {
        _this.showAmountText($toShow);
      }
    } else {
      $toShow = $('.per-amount-text[data-amount=250]');
      if ($toShow) {
        _this.showAmountText($toShow);
      }
    }
  },

  showAmountText: function ($toShow) {
    const $perAmountText = $('.per-amount-text');
    if ($toShow.hasClass('visible')){
      return;
    } else {
      $perAmountText.hide().removeClass('visible');
      $toShow.fadeIn().addClass('visible');
    }
  },

  render: function () {
    this.donationUpdateAmount();
  },
});

export default People;
